// src/components/RazorpayButton.jsx — full file
import { useEffect, useRef } from "react";

export default function RazorpayButton({ buttonId }) {
  const formRef = useRef(null);

  useEffect(() => {
    const form = formRef.current;
    if (!form) return;

    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/payment-button.js";
    script.dataset.payment_button_id = buttonId;
    script.async = true;
    form.appendChild(script);

    return () => {
      // We only ever clean up the node we created ourselves.
      // The <form> itself is unmounted by React (via the `key` prop
      // at the call site) whenever buttonId changes, so we never fight
      // React's reconciler over DOM that Razorpay's script also touches.
      if (form.contains(script)) form.removeChild(script);
    };
  }, [buttonId]);

  return <form ref={formRef}></form>;
}